import jwt_decode from "jwt-decode";

// constants
const SET_USER = "SET_USER";
const LOGOUT_USER = "LOGOUT_USER";

// actions
export const setUser = (payload) => {
  var decoded = jwt_decode(payload.token);
  return {
    type: SET_USER,
    payload: { ...payload, ...decoded },
  }
};

export const logout = (payload) => ({
  type: LOGOUT_USER,
  payload,
});

// reducer
const initialState = null;

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_USER:
      return { ...payload };
    case LOGOUT_USER:
      return null;
    default:
      return state;
  }
};

export default reducer;
